import React from "react";
import {
  HeroSection,
  HeroContent,
  HeroTopSection,
  HeroText,
  SubHeading,
  Title,
  Description,
  ButtonGroup,
  PrimaryButton,
  SecondaryButton,
  StatsGrid,
  StatItem,
  StatLabel,
  StatValue,
  HeroImageContainer,
  HeroImage,
} from "./SellAiStyledComponents";

interface SellAiHeroProps {
  onStartValuation: () => void;
  onLogin: () => void;
}

const SellAiHero: React.FC<SellAiHeroProps> = ({ onStartValuation, onLogin }) => {
  return (
    <HeroSection>
      <HeroContent>
        <HeroTopSection>
          <HeroText>
            <SubHeading>
              <span style={{ color: '#d92b3c', marginRight: '8px' }}>—</span> 
              <span style={{ color: '#d92b3c' }}>Zipang CARAT PRO</span> · VALUATION ENGINE
            </SubHeading>
            <Title>
              What is your jewellery <span style={{ fontStyle: 'italic', color: '#d92b3c' }}>real worth?</span>
            </Title>
            <Description>
              <p style={{ margin: '0 0 1rem 0' }}>
                Tell us about your ring or necklace. We'll show you what pieces like it have actually sold for.
              </p>
              <p style={{ margin: 0 }}>
                If we haven't seen enough pieces like yours, we'll say so.
              </p>
            </Description>
            <ButtonGroup>
              <PrimaryButton onClick={onStartValuation}>
                Start valuation &rarr;
              </PrimaryButton>
              <SecondaryButton onClick={onLogin}>
                Dealer or bulk? Trade portal
              </SecondaryButton>
            </ButtonGroup>
          </HeroText>
          <HeroImageContainer>
            <HeroImage src="https://ds29nc3ljdjce.cloudfront.net/zipang/sell_ai.gif" alt="Sell AI" />
          </HeroImageContainer>
        </HeroTopSection>
        
        <StatsGrid>
          <StatItem>
            <StatLabel>We Price</StatLabel>
            <StatValue><span>Anything</span> with a diamond in it</StatValue>
          </StatItem>
          <StatItem>
            <StatLabel>Based on</StatLabel>
            <StatValue><span>20 yrs</span> of experience</StatValue>
          </StatItem>
          <StatItem>
            <StatLabel>Confirmed by</StatLabel>
            <StatValue><span>Gemologist</span> within 1 business day</StatValue>
          </StatItem>
          <StatItem>
            <StatLabel>Sourced across</StatLabel>
            <StatValue><span>4 hubs</span> Tokyo · HK · NY · Dubai</StatValue>
          </StatItem>
        </StatsGrid>
      </HeroContent>
    </HeroSection>
  );
};

export default SellAiHero;
